import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function ProductShowcase() {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    id: 'T1',
    title: '📘 TOMO 1 — Seguridad Eléctrica y Oficio Técnico',
    desc: 'Protocolos de seguridad internacional, EPP y formación profesional del electricista.'
  }, {
    id: 'T2',
    title: '📗 TOMO 2 — Canalizaciones y Canalización',
    desc: 'Selección de tuberías, bandejas y dimensionamiento real de conductores.'
  }, {
    id: 'T3',
    title: '📙 TOMO 3 — Circuitos de Iluminación y Fuerza',
    desc: 'Diseño de circuitos residenciales y comerciales bajo estándares de seguridad.'
  }, {
    id: 'T4',
    title: '📕 TOMO 4 — Tableros y Protecciones',
    desc: 'Coordinación de protecciones, cálculo de carga y selección de dispositivos.'
  }, {
    id: 'T5',
    title: '📓 TOMO 5 — Automatización y Circuitos Especiales',
    desc: 'Introducción a controles básicos y lógica eléctrica.'
  }, {
    id: 'T6',
    title: '📔 TOMO 6 — El Maletín del Instructor',
    desc: 'Carpeta de planificación con secuencias didácticas por unidad.'
  }];
  const includes = ['Explicaciones técnicas listas para enseñar sin adaptar.', 'Ejemplos reales de instalaciones residenciales e industriales.', 'Fichas de trabajo práctico listas para fotocopiar/imprimir.', 'Preguntas guía para cierre de clase.', 'Evaluaciones completas con consignas claras.', 'Rúbricas y criterios de corrección para el taller.'];
  return <section className="py-10 px-4 bg-brand-card" data-id="element-100">
      <div className="max-w-xl mx-auto" data-id="element-101">
        <div className="text-center mb-8" data-id="element-102">
          <h2 className="text-xl md:text-2xl font-black text-white mb-2" data-id="element-103">
            🏆 KIT COMPLETO INSTALACIONES ELÉCTRICAS
          </h2>
          <p className="text-sm font-bold text-brand-accent mb-2" data-id="element-104">
            6 Tomos + 4 Bonos + Proyectos Integradores — Todo resuelto.
          </p>
          <p className="text-sm text-gray-400" data-id="element-105">
            Más de 400 páginas listas para usar en el taller y en el aula.
          </p>
        </div>

        <div className="text-center mb-6" data-id="element-106">
          <h3 className="text-lg font-black text-white bg-brand-dark px-4 py-2 rounded-md border border-white/10" data-id="element-107">
            ⚡ 6 TOMOS MAESTROS: Electrotecnia aplicada al taller técnico
          </h3>
        </div>

        <div className="flex flex-col gap-3 mb-10" data-id="element-108">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-dark border border-white/10 rounded-md overflow-hidden" data-id="element-109">
              <button onClick={() => setOpenTomo(openTomo === i ? null : i)} className="w-full p-4 text-left flex items-center justify-between focus:outline-none" data-id="element-110">
                <span className={`text-sm font-bold ${openTomo === i ? 'text-brand-accent' : 'text-white'}`} data-id="element-111">
                  {tomo.title}
                </span>
                {openTomo === i ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0 ml-2" data-id="element-112" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0 ml-2" data-id="element-113" />}
              </button>

              {openTomo === i && <div className="px-4 pb-4" data-id="element-114">
                  <div className="border-t border-white/5 pt-3" data-id="element-115">
                    <p className="text-sm text-gray-300 leading-relaxed" data-id="element-116">
                      {tomo.desc}
                    </p>
                  </div>
                </div>}
            </div>)}
        </div>

        <div className="bg-brand-dark rounded-md border border-white/10 p-5" data-id="element-117">
          <h4 className="text-base font-bold text-brand-accent mb-4 text-center" data-id="element-118">
            ✅ CADA TOMO INCLUYE:
          </h4>
          <ul className="space-y-3" data-id="element-119">
            {includes.map((item, i) => <li key={i} className="flex items-start text-sm text-gray-300" data-id="element-120">
                <span className="text-brand-accent mr-2" data-id="element-121">✔</span>
                <span data-id="element-122">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}